<template>

    <div class="foxy-loader">
        <div class="loader"></div>
        <div class="portrait"></div>
    </div>

</template>

<script>

import LottieLoader from '../components/lottie/LottieLoader'

export default {

    name: 'foxy-loader',

    props: {

        size: {
            type: Number,
            default: 64
        }
    },

    components: {LottieLoader}

}

</script>

<style lang="scss" scoped>

.foxy-loader {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;

    .loader {
        //extend global loader class
        width: 64px;
        height: 64px;
        border-top-color: $aquamarine;
        background-color: $white;
    }

    .portrait {
        background-image: url("/img/foxy/face.svg");
        background-repeat: no-repeat;
        background-size: cover;
        background-position-y: 3px;
        position: absolute;
        width: 48px;
        height: 48px;
        object-fit: contain;
        border-radius: 24px;
        background-color: $alice;
    }
}

</style>
